module.exports = __webpack_public_path__ + "static/media/cloud3.996b32dd.png";